<div class='label'>You will receive</div>
<div class='label'>
  <app-counter class='amount' [value]='(amountView|async)!'></app-counter>
  <img loading='lazy' [src]='icon' [alt]='symbol' class='w-[16px] h-[16px]' (error)='onIconError($event)'>
</div>
